<template>
  <div class="login-page">
    <div class="login-fit">
      <div class="login-brand">
        <div class="login-logo-wrap">
          <img
            class="login-logo"
            alt="Accountexec"
            src="../../public/logo_with_tm.png"
          />
        </div>
        <div class="brand-tagline-stage">
          <div class="srm-tagline">Sales Relationship Management (SRM)</div>
          <div class="brand-tagline">Make the most of your Sales Ecosystem!!!</div>
        </div>
      </div>
      <v-form class="login-form" @submit.prevent="handleSubmit()">
        <v-row dense>
          <v-col v-if="loginFailed" cols="12">
            <v-alert type="error">
              Login failed - please check your credentials and try again.
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="email"
              required
              dense
              :rules="[required, mustBeEmail]"
              label="Email"
              clearable
              name="email"
              :disabled="sendingLoginRequest"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="password"
              required
              dense
              :rules="[required]"
              label="Password"
              clearable
              name="password"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :disabled="sendingLoginRequest"
              @click:append="showPassword = !showPassword"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <router-link
              class="forgot-link"
              :to="{ name: 'forgot', query: emailTrimmed ? { email: emailTrimmed } : {} }"
            >
              Forgot your password?
            </router-link>
          </v-col>
          <v-col cols="12" class="py-1">
            <div class="login-pitch">Stop searching.&nbsp;&nbsp;Start Selling!!!</div>
          </v-col>
          <v-col cols="12">
            <div class="login-actions">
              <v-btn
                class="white--text login-btn-primary"
                color="blue"
                type="submit"
                name="submit"
                :disabled="sendingLoginRequest"
              >
                Login
              </v-btn>
              <v-btn
                class="white--text login-btn-signup"
                color="grey darken-1"
                name="create_account"
                :to="{ name: 'register' }"
                :disabled="sendingLoginRequest"
              >
                Let's GO!&nbsp;&nbsp;Sign Me Up!
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { applyAuthSession, postAuthDestination } from '../authSession'
// @ is an alias to /src

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
        sendingLoginRequest: false,
        loginFailed: false,
        email: '',
        password: '',
        showPassword: false,
        emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    }
  },
  mounted () {
    this.$nextTick(() => this.disableClearIconTabStops())
  },
  updated () {
    this.$nextTick(() => this.disableClearIconTabStops())
  },
  methods: {
    // Keep clearable (X) mouse-clickable, but out of keyboard tab order.
    disableClearIconTabStops () {
      if (!this.$el || !this.$el.querySelectorAll) return
      this.$el.querySelectorAll('.v-input__icon--clear').forEach(icon => {
        icon.setAttribute('tabindex', '-1')
        icon.querySelectorAll('button, [tabindex], .v-icon').forEach(el => {
          el.setAttribute('tabindex', '-1')
        })
      })
    },
    required (value) {
        return value !== '' ? true : 'Required'
    },
    mustBeEmail (value) {
        // Regex is lowercase-only; accept mixed-case input (API login is iexact).
        const v = value == null ? '' : String(value).trim().toLowerCase()
        return this.emailRegex.test(v) ? true : 'Must be a valid email'
    },
    validateBeforeSubmit () {
        return this.required(this.email) === true && this.required(this.password) === true && this.mustBeEmail(this.email) === true
    },
    handleSubmit () {
        const { email, password } = this

        if (this.validateBeforeSubmit()) {
            this.loginFailed = false;
            this.sendingLoginRequest = true;
            axios.post(`${this.$store.getters.baseURL}/api/user/login/`, {
                email, password
            })
            .then(res => {
                applyAuthSession(this.$store, res.data)
                this.sendingLoginRequest = false
                this.$router.push(postAuthDestination(res.data, this.$route.query)).catch(() => {})
              })
            .catch(err => {
                console.error(err)
                this.loginFailed = true
                this.sendingLoginRequest = false;
            })
        }
    },
},
  computed: {
    emailTrimmed () {
      return (this.email || '').trim()
    },
    formIsValid () {
      return this.validateBeforeSubmit()
    }
  }
}
</script>

<style scoped>
/*
 * Logo + slogans at the top. Form sits just below viewport center
 * (grid 50% / auto / 1fr). Spotlight is on the two-line slogan stage.
 * SRM pulse is infinite via transform so it never wraps to two lines.
 */
.login-page {
  box-sizing: border-box;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  display: flex;
  justify-content: center;
  padding: 8px 20px 40px;
  overflow-x: hidden;
  overflow-y: auto;
}
.login-fit {
  display: grid;
  grid-template-rows: minmax(0, 50%) auto 1fr;
  width: 100%;
  max-width: min(46rem, calc(100vw - 32px));
  height: 100%;
  min-height: 0;
  overflow: visible;
}
.login-brand {
  grid-row: 1;
  align-self: start;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  padding-top: 4px;
}
.login-logo-wrap {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.login-logo {
  max-height: min(12.5rem, 26vh);
  max-width: min(12.5rem, 70%);
  width: auto;
  height: auto;
  object-fit: contain;
}
.login-form {
  grid-row: 2;
  justify-self: center;
  width: 100%;
  max-width: 32rem;
  padding-bottom: 4px;
}
.login-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  width: 100%;
}
.login-actions .v-btn {
  flex: 1 1 0;
  height: auto;
  min-height: 36px;
  white-space: normal;
  line-height: 1.25;
  padding: 8px 10px;
}
/* Default CTA — Material blue, never the muted disabled wash */
.login-btn-primary {
  background-color: #2196f3 !important;
  border-color: #2196f3 !important;
}
/* Italic like “Make the…”, cyan like SRM */
.login-pitch {
  text-align: center;
  font-style: italic;
  font-weight: 400;
  font-size: clamp(0.82rem, 2.55vw, 1.7rem);
  color: #00B0F0;
  white-space: nowrap;
  line-height: 1.3;
  margin: 2px 0 4px;
}
.forgot-link {
  display: inline-block;
  color: #1976d2;
  text-decoration: none;
  font-size: 0.9rem;
  min-height: 32px;
  line-height: 32px;
}
.forgot-link:hover {
  text-decoration: underline;
}

.font-weight-bold {
  font-weight: 600;
}

.font-weight-extra-thin {
  font-weight: 200;
}

.brand-tagline-stage {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
  max-width: 100%;
  margin: 2px auto 0;
  padding: 0.55rem 0.15rem;
  /* Must stay visible: hidden clips the circular beam to this box's square edges. */
  overflow: visible;
}

/* Soft round spotlight — covers both slogan lines; paints past the glyph box. */
.brand-tagline-stage::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 6.25rem;
  height: 6.25rem;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(125, 216, 247, 0.5) 0%,
    rgba(0, 176, 240, 0.34) 24%,
    rgba(0, 176, 240, 0.14) 48%,
    rgba(0, 176, 240, 0.05) 66%,
    transparent 78%
  );
  transform: translate(-100%, -50%);
  animation: brand-shine 5.5s ease-in-out 2s infinite;
  pointer-events: none;
  filter: blur(3px);
  z-index: 2;
}

/* Slow forever-pulse: SRM is the product category, not a CRM */
.srm-tagline {
  position: relative;
  z-index: 1;
  font-family: 'Arial Rounded MT Bold', 'Arial Rounded MT', Arial, sans-serif;
  font-weight: normal;
  font-size: clamp(0.78rem, 2.15vw, 1.25rem);
  color: #00B0F0;
  letter-spacing: 0.01em;
  white-space: nowrap;
  transform-origin: center center;
  animation: srm-scale-pulse 6s ease-in-out infinite;
}

.brand-tagline {
  position: relative;
  z-index: 1;
  margin-top: 0.2rem;
  overflow: visible;
  font-style: italic;
  font-weight: 400;
  font-size: clamp(0.82rem, 2.55vw, 1.7rem);
  color: #212121;
  white-space: nowrap;
}

@keyframes srm-scale-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.14); }
}

@keyframes brand-shine {
  /* Fully off-stage so entry/exit are the circle, not a flat box edge. */
  0%, 12% {
    left: 0;
    transform: translate(-100%, -50%);
  }
  48%, 100% {
    left: 100%;
    transform: translate(0, -50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .srm-tagline {
    animation: none;
  }

  .brand-tagline-stage::after {
    animation: none;
    display: none;
  }
}

/*
 * Phone / DevTools device mode (aligned with Phone Smarty &lt;768).
 * Keep brand + form usable; desktop rules above unchanged.
 */
@media (max-width: 767px) {
  .login-page {
    padding:
      calc(4px + env(safe-area-inset-top, 0px))
      16px
      calc(16px + env(safe-area-inset-bottom, 0px));
    align-items: stretch;
  }
  .login-fit {
    grid-template-rows: auto auto 1fr;
    max-width: 100%;
    height: auto;
    min-height: 100%;
  }
  .login-brand {
    padding-top: 2px;
  }
  .login-logo {
    max-height: min(5.5rem, 18vh);
    max-width: min(9rem, 55%);
  }
  .brand-tagline-stage {
    width: 100%;
    max-width: 100%;
    padding: 0.35rem 0.1rem;
    margin-top: 0;
  }
  .brand-tagline-stage::after {
    width: 4rem;
    height: 4rem;
    opacity: 0.85;
  }
  .srm-tagline {
    font-size: clamp(0.72rem, 3.4vw, 0.95rem);
    white-space: normal;
    text-align: center;
    line-height: 1.25;
    animation: none;
  }
  .brand-tagline {
    font-size: clamp(0.78rem, 3.8vw, 1.05rem);
    white-space: normal;
    text-align: center;
    line-height: 1.3;
  }
  .login-form {
    max-width: 100%;
    padding-top: 4px;
  }
  .login-pitch {
    font-size: clamp(0.8rem, 3.6vw, 1rem);
    white-space: normal;
    margin: 4px 0 8px;
  }
  .forgot-link {
    min-height: 44px;
    line-height: 44px;
  }
  .login-actions {
    flex-direction: column;
    gap: 10px;
  }
  .login-actions .v-btn {
    min-height: 44px;
    width: 100%;
    flex: none;
  }
  /* Thumb-friendly fields without changing desktop Vuetify density. */
  .login-form >>> .v-text-field__slot input,
  .login-form >>> .v-input input {
    min-height: 44px;
    font-size: 16px; /* iOS: avoid focus zoom */
  }
  .login-form >>> .v-btn {
    min-height: 44px;
  }
}
</style>
